document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".bb-delivery-estimator").forEach(widget => {

    const cutoffHour = parseInt(widget.dataset.cutoff, 10);
    const shippingDays = parseInt(widget.dataset.shipDays, 10);

    const timerEl = widget.querySelector(".bb-timer");
    const deliveryEl = widget.querySelector(".bb-delivery-date");

    const orderDateEl = widget.querySelector(".bb-date-order");
    const shipDateEl = widget.querySelector(".bb-date-ship");
    const deliveryDateEl = widget.querySelector(".bb-date-delivery");

    const CHILE_HOLIDAYS = [
      "01-01", // Año Nuevo
      "05-01", // Día del Trabajador
      "06-21", // Día de los Pueblos Originarios
      "06-29", // San Pedro y San Pablo
      "07-16", // Virgen del Carmen
      "08-15", // Asunción de la Virgen
      "09-18", // Independencia de Chile
      "09-19", // Glorias del Ejército
      "10-12", // Día de la Raza
      "10-31", // Día de las Iglesias Evangélicas y Protestantes
      "11-01", // Día de los Muertos
      "12-08", // Inmaculada Concepción
      "12-25" // Navidad
    ];

    function isHoliday(date){
      const mmdd = String(date.getMonth()+1).padStart(2,"0") + "-" +
                  String(date.getDate()).padStart(2,"0");
      return CHILE_HOLIDAYS.includes(mmdd);
    }

    function addBusinessDays(date, days){
      let result = new Date(date);
      while(days > 0){
        result.setDate(result.getDate() + 1);
        const isWeekend = result.getDay() === 0 || result.getDay() === 6;
        if(!isWeekend && !isHoliday(result)){
          days--;
        }
      }
      return result;
    }

    function formatDate(date){
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}/${month}`;
    }

    function updateTimer(){
      const now = new Date();
      let cutoff = new Date();
      cutoff.setHours(cutoffHour,0,0,0);

      if(now > cutoff){
        cutoff.setDate(cutoff.getDate() + 1);
      }

      const diff = cutoff - now;

      if(diff <= 0){
        timerEl.innerText = "00:00:00";
        return;
      }

      const h = String(Math.floor(diff/1000/60/60)).padStart(2,"0");
      const m = String(Math.floor(diff/1000/60)%60).padStart(2,"0");
      const s = String(Math.floor(diff/1000)%60).padStart(2,"0");

      timerEl.innerText = `${h}:${m}:${s}`;
    }

    function calculateShipDate(orderDate, cutoffHour){
      let shipDate = new Date(orderDate);
      const hour = shipDate.getHours();
      const day = shipDate.getDay(); 

      const isWeekend = day === 0 || day === 6;
      const afterCutoff = hour >= cutoffHour;
      const isHolidayToday = isHoliday(shipDate);

      // Si es fin de semana o feriado -> mover al próximo día hábil
      if(isWeekend || isHolidayToday){
        shipDate = addBusinessDays(shipDate, 1);
        shipDate.setHours(0,0,0,0);
        return shipDate;
      }

      // Viernes después del cutoff -> lunes
      if(day === 5 && afterCutoff){
        shipDate = addBusinessDays(shipDate, 1);
        shipDate.setHours(0,0,0,0);
        return shipDate;
      }

      // Lunes a viernes después del cutoff
      if(afterCutoff){
        shipDate = addBusinessDays(shipDate, 1);
        shipDate.setHours(0,0,0,0);
        return shipDate;
      }

      // Antes del cutoff -> mismo día
      shipDate.setHours(0,0,0,0);
      return shipDate;
    }

    setInterval(updateTimer,1000);
    updateTimer();

    const orderDate = new Date();
    const shipDate = calculateShipDate(orderDate, cutoffHour);
    
    // Configuración base por defecto
    let deliveryDate = addBusinessDays(shipDate, shippingDays);

    deliveryEl.innerText = formatDate(shipDate); // BANNER PRINCIPAL MUESTRA SHIP DATE
    orderDateEl.innerText = formatDate(orderDate);
    shipDateEl.innerText = formatDate(shipDate);
    deliveryDateEl.innerText = formatDate(deliveryDate);

    // BLUE EXPRESS SELECTORS
    const regionSelect = widget.querySelector(".bb-region-select");
    const comunaSelect = widget.querySelector(".bb-comuna-select");
    const comunaGroup = widget.querySelector(".bb-comuna-group");
    const deliveryMsg = widget.querySelector(".bb-delivery-message");

    function initSelects() {
      if (!window.blueExpressData) return;
      
      const regiones = Object.keys(window.blueExpressData);
      
      if (regionSelect && regionSelect.options.length <= 1) {
        regiones.forEach(region => {
          const option = document.createElement("option");
          option.value = region;
          option.innerText = region;
          regionSelect.appendChild(option);
        });
      }
    }

    // Try immediately
    if (window.blueExpressData) {
      initSelects();
    } else {
      let intents = 0;
      const interval = setInterval(() => {
        if (window.blueExpressData) {
          initSelects();
          clearInterval(interval);
        }
        if (intents++ > 20) clearInterval(interval); 
      }, 100);
    }

    if (regionSelect && comunaSelect) {
      regionSelect.addEventListener("change", function () {
        const selectedRegion = this.value;
        comunaSelect.innerHTML = '<option value="">Selecciona una comuna...</option>';
        deliveryMsg.style.display = "none";
        
        if (selectedRegion && window.blueExpressData[selectedRegion]) {
          comunaGroup.style.display = "flex";
          const comunas = window.blueExpressData[selectedRegion];
          for (const comuna in comunas) {
            const option = document.createElement("option");
            option.value = comuna;
            option.innerText = comuna;
            comunaSelect.appendChild(option);
          }
        } else {
          comunaGroup.style.display = "none";
        }
      });

      comunaSelect.addEventListener("change", function () {
        const selectedRegion = regionSelect.value;
        const selectedComuna = this.value;
        
        if (selectedRegion && selectedComuna && window.blueExpressData[selectedRegion][selectedComuna]) {
          const info = window.blueExpressData[selectedRegion][selectedComuna];
          const estimatedTimeStr = info.tiempo_entrega;
          
          if (estimatedTimeStr && estimatedTimeStr.toLowerCase() !== "no disponible") {
            deliveryMsg.style.display = "block";

            let finalShipDate = shipDate;
            let finalDeliveryDate;
            const sameDayComunas = ["Cerrillos", "Cerro Navia", "Colina", "Conchalí", "El Bosque", "Estación Central", "Huechuraba", "Independencia", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Lampa", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "Ñuñoa", "Padre Hurtado", "Pedro Aguirre Cerda", "Peñalolén", "Providencia", "Puente Alto", "Pudahuel", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "Santiago", "San Joaquín", "San Miguel", "San Ramón", "San Bernardo", "Vitacura"];
            
            if (sameDayComunas.includes(selectedComuna)) {
                deliveryMsg.innerText = "Entrega el mismo día";
                finalDeliveryDate = finalShipDate;
            } else {
                deliveryMsg.innerText = estimatedTimeStr;
                const numeros = estimatedTimeStr.match(/\d+/g);
                let addedDays = shippingDays; 
                if (numeros && numeros.length > 0) {
                   addedDays = parseInt(numeros[numeros.length - 1], 10);
                }
                finalDeliveryDate = addBusinessDays(finalShipDate, addedDays);
            }

            deliveryEl.innerText = formatDate(finalShipDate); // Main timer text now shows SHIP date
            deliveryDateEl.innerText = formatDate(finalDeliveryDate);
          } else {
            deliveryMsg.style.display = "none";
          }
        } else {
          deliveryMsg.style.display = "none";
        }
      });
    }

  });

});